module.exports = __webpack_public_path__ + "img/3-1.e4b994ba.svg";